import { useMutation } from '@tanstack/react-query';
import { MutationCallbacks } from '../../../../shared/types/mutation';
import { signInWithEmailAndPassword } from '../../../../shared/service/auth';

export default function useSignInWithEmail(
  email: string,
  password: string,
  { onSuccess, onError }: MutationCallbacks,
) {
  return useMutation({
    mutationFn: () => signInWithEmailAndPassword(email, password),
    onSuccess,
    onError,
    throwOnError: false,
  });
}
